import { ContactForm } from "@models/MLTC_R3/Contact.model";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ContactState {
  contact: ContactForm | null;
}

const initialState: ContactState = {
  contact: null,
}

const contactSlice = createSlice({
  name: 'MLTC-R3-Contact',
  initialState,
  reducers: {
    updateContact: (state, action: PayloadAction<ContactForm | null>) => {
      state.contact = action.payload;
    }
  },
  extraReducers: {}
})

export const { updateContact } = contactSlice.actions;

export default contactSlice.reducer;